export const GET_INGREDIENTS_REQUEST: 'GET_ITEMS_REQUEST' = 'GET_ITEMS_REQUEST';
export const GET_INGREDIENTS_SUCCESS: 'GET_ITEMS_SUCCESS' = 'GET_ITEMS_SUCCESS';
export const GET_INGREDIENTS_FAILED: 'GET_ITEMS_FAILED' = 'GET_ITEMS_FAILED';
export const INCREASE_COUNT: 'INCREASE_COUNT' = 'INCREASE_COUNT';
export const DECREASE_COUNT: 'DECREASE_COUNT' = 'DECREASE_COUNT';
export const SET_COUNT: 'SET_COUNT' = 'SET_COUNT';
